<template>
    <v-container>
        <v-row justify="center">
             <v-img alt="Sennheiser Logo" :max-width="300" transition="scale-transition"
                :src="require('@/assets/Sennheiser_logo.png')" />
        </v-row>
        <v-card color="basil">
            <v-card-title class="text-center justify-center">
                ドイツの音響機器メーカー"Sennheiser"の取扱い
            </v-card-title>

            <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
                <v-tab v-for="item in items" :key="item">
                    {{ item.title }}
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
                <v-tab-item v-for="item in items" :key="item">
                    <v-carousel cycle min-height="350" hide-delimiter-background show-arrows-on-hover>
                        <v-carousel-item v-for="(resource, i) in item.resources" :key="i" :src="resource"
                            reverse-transition="fade-transition" transition="fade-transition"></v-carousel-item>
                    </v-carousel>
                    <v-card color="basil" flat>
                        <v-card-text>
                            {{ item.description }}
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
    </v-container>
</template>
  

<script>
export default {
    name: 'SennheiserPromo',
    data: () => ({
        tab: null,
        items: [
            {
                title: 'ADAPT Presence', description: '1 test', resources: [
                    require('@/assets/sennheiser/IMG_9447_1.png'),
                ]
            },
            {
                title: 'EXPAND 20', description: '2 test', resources: [
                    require('@/assets/sennheiser/IMG_9448_1.png'),
                ]
            },
            {
                title: 'IMPACT 100', description: '3 test', resources: [
                    require('@/assets/sennheiser/IMG_9449_1.png'),
                ]
            },
        ],
    }),

    methods: {
    },
}
</script>
  